// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__3w6o0","breadcrumbs__element":"Breadcrumbs_breadcrumbs__element___xplh","active":"Breadcrumbs_active__2I7aE"};